const selector = '.person-latest';
const node = document.querySelector( selector );

function onClick( e ) {
	let target = e.target;

	while ( target && target !== node ) {
		if ( target.matches( '.person-latest__pagination a[href]' ) ) {
			e.preventDefault();
			fetchUrl( target.href, true );
			break;
		}

		target = target.parentNode;
	}
}

function onPopstate() {
	fetchUrl( window.location.href, false );
}

async function fetchUrl( url, pushState = false ) {
	node.classList.add( 'is-loading' );

	return fetch( url )
		.then( ( response ) => {
			if ( ! response.ok ) {
				throw response;
			}

			return response.text();
		} )
		.then( ( html ) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString( html, 'text/html' );
			const docNode = doc.querySelector( selector );

			document.title = doc.title;

			if ( docNode ) {
				node.innerHTML = docNode.innerHTML;
			} else {
				throw new Error( 'There was an error loading more items.' );
			}

			if ( pushState ) {
				window.history.pushState( {}, '', url );
			}
		} )
		.catch( ( fault ) => {
			console.error( fault );

			while ( node.firstChild ) {
				node.removeChild( node.firstChild );
			}

			const errorNode = document.createElement( 'p' );
			errorNode.classList.add( 'error' );

			if ( fault instanceof Response && 404 === fault.status ) {
				errorNode.innerHTML = `No results found for your filters. Please try again.`;
			} else {
				errorNode.innerHTML = fault.toString();
			}

			const back = document.createElement( 'button' );
			back.appendChild( document.createTextNode( 'Back' ) );
			back.addEventListener( 'click', () => window.history.back() );

			node.appendChild( errorNode );
			node.appendChild( back );
		} )
		.finally( () => {
			node.classList.remove( 'is-loading' );

			if ( node.getBoundingClientRect().top < 0 ) {
				node.scrollIntoView( { behavior: 'smooth' } );
			}
		} );
}

if ( node ) {
	node.addEventListener( 'click', onClick );
	window.addEventListener( 'popstate', onPopstate );
}

